import React from 'react'

import * as styles from './support.module.scss'
import IntroBannerWithBackground from '../../components/banners/intro-banner-with-background/IntroBannerWithBackground'
import Container from '../../components/container/Container'
import SEOControl from '../../components/seoControl/seoControl'
import USAWaitingList from '../../components/usa-waiting-list/USAWaitingList'
import { colors } from '../../constants/style'

const TITLE = 'Bamboo - Support'
const DESCRIPTION =
  'Our team is ready and willing to help with any issues or queries you have about your user experience.'
const KEYWORDS =
  'bamboo, blockchain, gold, silver, precious metals, bitcoin, ethereum, digital assets, litecoin, crypto, buy, invest, invest today, micro investment, microinvestment, micro-investment, solvency protocol, proof of solvency, spare change, contact, support'

function SupportPage() {
  return (
    <>
      <SEOControl title={TITLE} description={DESCRIPTION} keywords={KEYWORDS} />

      <IntroBannerWithBackground
        backgroundColor={colors.blue400}
        title={
          <>
            <span>We’re here to help.</span>
            <br />
            <span>Supporting you along the way.</span>
          </>
        }
        subtitle="Our team is ready and willing to help with any issues or queries you have about your user experience. Get in touch via the links below."
      />
      <section className={styles.section}>
        <Container>
          <div className={styles.wrapper}>
            <div className={styles.blocksWrapper}>
              <a
                href="https://getbamboo.typeform.com/to/qpUVkI"
                className={styles.block}
              >
                <div className={styles.blockName}>Report a bug</div>
                <p className={styles.blockText}>
                  Bugs can be annoying. Let us know what’s bothering you via a
                  short form and we’ll look into it for you.
                </p>
                <span className={styles.action}>Fill out a report &gt;</span>
              </a>

              <a href="mailto:support@getbamboo.io" className={styles.block}>
                <div className={styles.blockName}>Send us a message</div>
                <p className={styles.blockText}>
                  Got something on your mind you think we should know about?
                  Drop us an email and we’ll be in touch.
                </p>
                <span className={styles.action}>Send us an email &gt;</span>
              </a>
            </div>
          </div>
        </Container>
      </section>
      <USAWaitingList />
    </>
  )
}

export default SupportPage
